
import {
  defineComponent,
  computed,
  useContext,
  ref,
  watch,
  useRoute,
} from '@nuxtjs/composition-api';
import CategoryProducts from '~/domains/category/components/CategoryProducts';

export default defineComponent({
  name: 'CategoryCatalogContent',
  components: {
    CategoryProducts,
  },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    totalPages: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    selectedFilters: {
      type: Object,
      default: () => {},
    },
    isFiltersVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { i18n } = useContext();
    const route = useRoute();
    const itemsCount = computed(() => {
      return props.category
        ? `${props.category.products_meta_count} ${
            props.category.products_meta_count === 1
              ? i18n.tc('item', 1)
              : i18n.tc('item', 0)
          }`
        : 0;
    });
    const catalogContent = ref(null);
    const currentPage = computed(() => +route.value.query.page || 1);
    const isShowBadge = computed(
      () => Object.keys(props.selectedFilters).length
    );

    const categoryProductsClass = computed(() => {
      const screenXLNoFilters = { 'xl:grid-cols-4': !props.isFiltersVisible };
      return screenXLNoFilters;
    });

    const isCategoryProducts = computed(
      () => props.category && props.category.products && !props.isLoading
    );

    watch(currentPage, () => {
      emit('onChangePage');
      catalogContent.value.scrollIntoView({
        alignToTop: true,
        behavior: 'smooth',
      });
    });

    return {
      currentPage,
      itemsCount,
      catalogContent,
      isShowBadge,
      categoryProductsClass,
      isCategoryProducts,
    };
  },
});
